import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(3),
  backgroundColor: theme.palette.grey[400],
  gap: theme.spacing(3),
}));

export const Description = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  color: theme.palette.grey[900],
}));
